import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ClientBar from './components/ClientBar';
import TwoVerticals from './components/TwoVerticals';
import ManufacturingDeepDive from './components/ManufacturingDeepDive';
import InspectionDeepDive from './components/InspectionDeepDive';
import FieldServicesDeepDive from './components/FieldServicesDeepDive';
import TheNumbers from './components/TheNumbers';
import GeographicReach from './components/GeographicReach';
import VisualShowcase from './components/VisualShowcase';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-[#1A1A2E]" data-testid="app-root">
        <Navbar />
        <Hero />
        <ClientBar />
        <TwoVerticals />
        <ManufacturingDeepDive />
        <InspectionDeepDive />
        <FieldServicesDeepDive />
        <TheNumbers />
        <GeographicReach />
        <VisualShowcase />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
